 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"dinein setting~menueditor":"dinein setting~menueditor","menueditor":"menueditor","createOrder~historyOrders~specialEventOrders~todayOrders":"createOrder~historyOrders~specialEventOrders~todayOrders","createOrder~specialEventOrders~todayOrders":"createOrder~specialEventOrders~todayOrders","createOrder":"createOrder","endOfDay~historyOrders~serverShift~specialEventOrders":"endOfDay~historyOrders~serverShift~specialEventOrders","historyOrders~specialEventOrders~todayOrders":"historyOrders~specialEventOrders~todayOrders","specialEventOrders":"specialEventOrders","historyOrders":"historyOrders","todayOrders":"todayOrders","delivery setting":"delivery setting","dinein setting":"dinein setting","endOfDay~serverShift":"endOfDay~serverShift","endOfDay":"endOfDay","serverShift":"serverShift","general setting":"general setting","itemAvailabilities":"itemAvailabilities","loyalty setting":"loyalty setting","support":"support","tipSummary":"tipSummary","togo setting":"togo setting","users setting":"users setting"}[chunkId]||chunkId) + "." + {"chunk-1db243ca":"ffa04c7b","chunk-3976d3fc":"349747c2","dinein setting~menueditor":"b1c5b2ff","menueditor":"d345dc4a","chunk-2d0b68b0":"f353d022","chunk-2d0bae9d":"58089df2","chunk-2d0d7da9":"84bc8100","chunk-2d0e5fb4":"e238ff1c","chunk-2d0efcaf":"93dba846","chunk-3ab33317":"a2fdc7da","chunk-fb7385a4":"5f629cfb","createOrder~historyOrders~specialEventOrders~todayOrders":"f8ab9c7c","createOrder~specialEventOrders~todayOrders":"938d1aef","createOrder":"b8deddb9","endOfDay~historyOrders~serverShift~specialEventOrders":"901f9bf3","historyOrders~specialEventOrders~todayOrders":"6fe363f6","specialEventOrders":"b40a7ae6","historyOrders":"ba611196","todayOrders":"de6d434e","delivery setting":"06969ba5","dinein setting":"1c2bc3b5","endOfDay~serverShift":"6d823073","endOfDay":"fe2d33ba","serverShift":"ec16bb1d","general setting":"95b77e5f","itemAvailabilities":"3bed782e","loyalty setting":"01dff029","support":"08a55db4","tipSummary":"ba31bb3d","togo setting":"d00bef5c","users setting":"c996bcff","chunk-b27dd9ce":"ffedf48b"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-1db243ca":1,"chunk-3976d3fc":1,"dinein setting~menueditor":1,"menueditor":1,"chunk-3ab33317":1,"chunk-fb7385a4":1,"createOrder~historyOrders~specialEventOrders~todayOrders":1,"createOrder~specialEventOrders~todayOrders":1,"createOrder":1,"historyOrders~specialEventOrders~todayOrders":1,"specialEventOrders":1,"historyOrders":1,"todayOrders":1,"delivery setting":1,"dinein setting":1,"endOfDay~serverShift":1,"endOfDay":1,"serverShift":1,"general setting":1,"itemAvailabilities":1,"loyalty setting":1,"support":1,"togo setting":1,"users setting":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"dinein setting~menueditor":"dinein setting~menueditor","menueditor":"menueditor","createOrder~historyOrders~specialEventOrders~todayOrders":"createOrder~historyOrders~specialEventOrders~todayOrders","createOrder~specialEventOrders~todayOrders":"createOrder~specialEventOrders~todayOrders","createOrder":"createOrder","endOfDay~historyOrders~serverShift~specialEventOrders":"endOfDay~historyOrders~serverShift~specialEventOrders","historyOrders~specialEventOrders~todayOrders":"historyOrders~specialEventOrders~todayOrders","specialEventOrders":"specialEventOrders","historyOrders":"historyOrders","todayOrders":"todayOrders","delivery setting":"delivery setting","dinein setting":"dinein setting","endOfDay~serverShift":"endOfDay~serverShift","endOfDay":"endOfDay","serverShift":"serverShift","general setting":"general setting","itemAvailabilities":"itemAvailabilities","loyalty setting":"loyalty setting","support":"support","tipSummary":"tipSummary","togo setting":"togo setting","users setting":"users setting"}[chunkId]||chunkId) + "." + {"chunk-1db243ca":"533ba257","chunk-3976d3fc":"d7a26877","dinein setting~menueditor":"9905a79c","menueditor":"71edfdb6","chunk-2d0b68b0":"31d6cfe0","chunk-2d0bae9d":"31d6cfe0","chunk-2d0d7da9":"31d6cfe0","chunk-2d0e5fb4":"31d6cfe0","chunk-2d0efcaf":"31d6cfe0","chunk-3ab33317":"b770007a","chunk-fb7385a4":"deb76e55","createOrder~historyOrders~specialEventOrders~todayOrders":"7e95fa94","createOrder~specialEventOrders~todayOrders":"6fda8a33","createOrder":"97831844","endOfDay~historyOrders~serverShift~specialEventOrders":"31d6cfe0","historyOrders~specialEventOrders~todayOrders":"5bb0e9a6","specialEventOrders":"69257d6c","historyOrders":"665aff21","todayOrders":"29a200dd","delivery setting":"b925169a","dinein setting":"07622111","endOfDay~serverShift":"533ba257","endOfDay":"a9fe8e2c","serverShift":"ec2d432c","general setting":"40b39f41","itemAvailabilities":"c534095b","loyalty setting":"1d0d52d3","support":"b6ac509c","tipSummary":"31d6cfe0","togo setting":"0c160eaa","users setting":"3b684c62","chunk-b27dd9ce":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
